export default __webpack_public_path__ + "static/media/View_carousal_Icon_Inactive.b52e1132.svg";